import { render, staticRenderFns } from "./TreeSelectDropdownTree.vue?vue&type=template&id=2b81cf4b"
import script from "./TreeSelectDropdownTree.vue?vue&type=script&lang=js"
export * from "./TreeSelectDropdownTree.vue?vue&type=script&lang=js"
import style0 from "./TreeSelectDropdownTree.vue?vue&type=style&index=0&id=2b81cf4b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports